import React from "react";
import ModelIcon, { MODEL_BRAND } from "./ModelIcon";

/**
 * ResearchModelAvatars - stacked brand marks showing which models are in play.
 * Presentation only.
 */
export default function ResearchModelAvatars({ models = [] }) {
  if (!models.length) return null;
  return (
    <div className="rw-avatars" aria-label={`Models: ${models.join(", ")}`}>
      {models.map((m) => (
        <span
          key={m}
          className="rw-avatar"
          data-model={m}
          title={m}
          style={{ background: MODEL_BRAND[m]?.color }}
        >
          <ModelIcon model={m} size={13} />
        </span>
      ))}
    </div>
  );
}
